<template>
    <div :style="containerStyle" class="timetable-container">
        <div class="timetable-header">
            <div
                    :style="headerStyle"
                    class="timetable-header-cell timetable-period"
            >
                節次/時間
            </div>
            <div
                    :key="idx"
                    :style="headerStyle"
                    class="timetable-header-cell"
                    v-for="(h, idx) in notWeekendPart"
            >
                {{h}}
            </div>
            <div :style="headerStyle" class="timetable-header-cell timetable-period">節次/時間</div>
            <div
                    :key="idx + 6"
                    :style="headerStyle"
                    class="timetable-header-cell"
                    v-for="(h, idx) in weekendPart"
            >
                {{h}}
            </div>
        </div>
        <div :style="bodyStyle" class="timetable-weeks">
            <div
                    :key="r"
                    :style="weekStyle"
                    class="timetable-week"
                    v-for="r in rows"
            >
                <div
                        :aria-disabled="isCellDisabled(c) ? 'true' : 'false'"
                        :class="computeCellClass(c)"
                        :key="`${r}_${c}`"
                        :style="cellStyle"
                        :title="isCellDisabled(c) ? '不在借用開放日期內' : null"
                        @click="handleCellClick({row:r, col:c})"
                        v-for="c in cols"
                >
                    <span
                            class="periodText"
                            v-if="c === 0"
                    >
                        {{periodsDefs.dayPeriods[r] | periodText}}
                    </span>
                    <span
                            class="periodText"
                            v-if="c === 6"
                    >
                        {{periodsDefs.collegePeriods[r] | periodText}}
                    </span>
                </div>

            </div>

            <div
                    :key="`${c}_content`"
                    v-for="c in cols"
            >
                <template v-if="timePlots[c]">
                    <timetable-content
                            :cls="computeContentClass({isPast, isFuture, isNow, type})"
                            :course-name="timePlots[c][idx].courseName"
                            :class-name="timePlots[c][idx].className"
                            :height="span * heightOfCell - begin * 0.5"
                            :is-future="isFuture"
                            :is-now="isNow"
                            :is-past="isPast"
                            :key="`${c}_${idx}`"
                            :offset-left="c * widthOfCell + begin * 0.5"
                            :offset-top="(begin - 1)  * heightOfCell + begin "
                            :type="type"
                            :width="widthOfCell - begin"
                            v-for="({span, begin, type, isPast, isFuture, isNow}, idx) in timePlots[c]"
                    >
                        <template
                                #default="{type}"
                        >
                            <span>{{type | cellType }}</span>
                        </template>
                        <template
                                #courseName="{courseName}"
                        >
                            <span>{{ courseName }}</span><br>
                        </template>
                        <br>
                        <template
                                #className="{className}"
                        >
                            <span>{{ className }}</span><br>
                        </template>
                    </timetable-content>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import TimetableContent from './TimetableContent'
import {TotalPeriods, Weekdays} from '../../constants';
import debounce from 'debounce';
import moment from 'moment';

const CellTypes = {
        Course: 0,
        Transferred: 1,
        Booked: 2
    };

    export default {
        name: 'TimetableContainer',
        components: {
            TimetableContent,
        },
        data: () => ({
            widthOfCell: 150,
            cls: 'timetable-content'
        }),
        computed: {

            headers() {
                return this.weeks.map(w => w.format('YYYY-MM-DD dd'));
            },

            notWeekendPart() {
                return this.headers.filter((_, idx) => idx < 5);
            },
            weekendPart() {
                return this.headers.filter((_, idx) => idx >= 5);
            },

            containerStyle() {
                return {}
            },

            headerStyle() {
                return {
                    height: `${this.heightOfHeader}px`,
                    lineHeight: `${this.heightOfHeader}px`,
                    //minWidth: `${this.widthOfCell}px`,
                    // maxWidth: `${this.widthOfCell}px`,
                }
            },

            cellStyle() {
                return {
                    height: `${this.heightOfCell}px`,
                    lineHeight: `${this.heightOfCell}px`,
                    //minWidth: `${this.widthOfCell}px`,
                    // maxWidth: `${this.widthOfCell}px`,
                }
            },
            bodyStyle() {
                return {
                    width: '100%',
                    height: `${this.heightOfCell * TotalPeriods + this.heightOfHeader}px`,
                    minHeight: `${this.heightOfCell * TotalPeriods + this.heightOfHeader}px`,
                }
            },

            weekStyle() {
                return {
                    width: '100%'
                }
            },
            rows() {
                return [...Array(TotalPeriods).keys()];
            },

            cols() {
                return [...Array(9).keys()];
            },

            onResize() {
                const self = this;
                return debounce(() => {
                    const header = document.querySelector('.timetable-cell');
                    const style = window.getComputedStyle(header);
                    self.widthOfCell = parseFloat(style.width) + 1 //border;
                }, 50);
            }
        },
        filters: {
            periodText({period, text}) {
                return `第${period}節(${text})`
            },

            cellType(type) {
                switch (type) {
                    case CellTypes.Course:
                        // return '已排(調)課';
                        return null;
                    case CellTypes.Transferred:
                        return '';
                    case CellTypes.Booked:
                        return '已被借用';
                    default:
                        return '';
                }
            }
        },
        props: {
            timePlots: {
                type: Object,
                required: true,
                default: () => {
                }
            },
            weeks: {
                type: Array,
                default: () => Weekdays.filter((_, idx) => idx !== 0)
            },

            heightOfHeader: {
                type: Number,
                default: 50
            },
            heightOfCell: {
                type: Number,
                default: 60
            },
            periodsDefs: {
                type: Object,
                default: () => ({
                    collegePeriods: [...Array(TotalPeriods).keys()]
                        .map(k => ({period: k + 1, text: ''})),
                    dayPeriods: [...Array(TotalPeriods).keys()]
                        .map(k => ({period: k + 1, text: ''}))
                })
            },
            onCellClick: {
                type: Function,
                default: () => {
                }
            },
            isDateSelectable: {
                type: Function,
                default: () => true
            }
        },
        methods: {
            computeContentClass(time) {
                let ret = 'timetable-content';
                const {isPast, isNow, isFuture, type} = time;
                if (isPast) {
                    ret = `${ret} past`
                } else if (isNow) {
                    ret = `${ret} now`
                } else if (isFuture) {
                    ret = `${ret} future`
                }

                switch (type) {
                    case CellTypes.Course:
                        ret = `${ret} course`;
                        break;
                    case CellTypes.Transferred:
                        ret = `${ret} transferred`;
                        break;
                    case CellTypes.Booked:
                        ret = `${ret} booked`;
                        break;
                }
                return ret;
            },

            getCellDate(col) {
                if (col === 0 || col === 6) return null;

                const fstWd = this.weeks[0];
                if (!moment(fstWd).isValid()) return null;

                const adjusted = col > 6 ? col - 1 : col;
                return moment(fstWd).add(adjusted - 1, 'd');
            },

            isCellDisabled(col) {
                const current = this.getCellDate(col);
                return current && !this.isDateSelectable(current);
            },

            handleCellClick(cellPosition) {
                const cell = this.computeCellObj(cellPosition);
                if (cell.isValid && !cell.isPast && !cell.isOutOfRange) {
                    this.onCellClick(cell);
                }
            },

            computeCellClass(col) {
                let ret = 'timetable-cell';
                if (col === 0 || col === 6) {
                    ret = `${ret} timetable-period`;
                }
                const current = this.getCellDate(col);
                if (current) {
                    if (this.isCellDisabled(col)) {
                        ret = `${ret} disabled`;
                    }
                    if (current.isBefore(moment(), 'd')) {
                        ret = `${ret} past`;
                    } else if (current.isAfter(moment(), 'd')) {
                        ret = `${ret} future`;
                    } else if (current.isSame(moment(), 'd')) {
                        ret = `${ret} now`;
                    }
                }

                return ret;
            },

            computeCellObj({row, col}) {
                if(col === 0 || col === 6) return {isValid: false};

                const current = this.getCellDate(col);
                if (current) {
                    const weekday = current.weekday() === 0 ? 7 : current.weekday();
                    let ret = {
                        period: row + 1,
                        isValid: true,
                        date: current.format('YYYY-MM-DD'),
                        weekday
                    };

                    if (this.isCellDisabled(col)) {
                        return {
                            ...ret,
                            isValid: false,
                            isOutOfRange: true
                        };
                    }

                    if (current.isBefore(moment(), 'd')) {
                        return {
                            ...ret,
                            isPast:true,
                        }
                    } else if (current.isAfter(moment(), 'd')) {
                        return {
                            ...ret,
                            isFuture:true
                        }
                    } else if (current.isSame(moment(), 'd')) {
                        return {
                            ...ret,
                            now:true
                        }
                    }
                }

                return {isValid: false};
            }
        },

        mounted() {
            const self = this;
            window.addEventListener('resize', self.onResize);
            self.onResize();
        },

        created() {
            //this.widthOfCell = this.$refs.periodFstHeader.clientWidth;
        },

        destroyed() {
            const self = this;
            window.removeEventListener('resize', self.onResize);
        }
    }
</script>

<style>
    .timetable-container {
        margin: 0;
        padding: 4px;

    }

    .timetable-header {
        margin: 0;
        width: 100%;
        display: flex;
    }

    .timetable-period {
        cursor: default;
    }

    .timetable-header .timetable-header-cell {
        text-align: center;
        line-height: 50px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        border-top: 1px solid #00ffcc;
        border-bottom: 1px solid #00ffcc;
        border-right: 1px solid #00ffcc;
        flex: 1 1 0;
    }

    .timetable-header .timetable-header-cell:first-child {
        border-left: 1px solid #00ffcc;
    }

    .timetable-header .timetable-header-cell.timetable-period {
        background-color: aliceblue;
    }

    .timetable-weeks {
        flex-wrap: wrap;
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        position: relative;
    }

    .timetable-weeks .timetable-week {
        display: flex;
        width: 100%;
        margin: 0;
    }

    .timetable-weeks .timetable-week .timetable-cell {
        text-align: center;
        border-bottom: 1px solid #00ffcc;
        border-right: 1px solid #00ffcc;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        flex: 1 1 0;
    }

    .timetable-weeks .timetable-week .timetable-cell.past {
        background-color: #f0f2f5;
    }

    .timetable-weeks .timetable-week .timetable-period {
        background-color: aliceblue;
        cursor: default;
    }

    .timetable-weeks .timetable-week .timetable-cell:first-child {
        border-left: 1px solid #00ffcc;
    }

    .timetable-cell {
        cursor: pointer;
    }

    .timetable-cell.past {
        cursor: not-allowed;
    }

    .timetable-cell.disabled {
        background-color: #f0f2f5;
        cursor: not-allowed;
        opacity: 0.65;
    }

    .timetable-cell.periodText {
        font-size: 0.9rem;
    }

    .timetable-content {
        position: absolute;
        z-index: 10;
        padding: 0;
        border: 1px solid ghostwhite;
        text-align: center;
        background-color: #fff;
        cursor: default;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: normal;
    }

    .timetable-content.past,
    .timetable-content.course.past,
    .timetable-content.transferred.past,
    .timetable-content.booked.past {
        background-color: #6699ff;
    }

    .timetable-content.now,
    .timetable-content.course.now,
    .timetable-content.transferred.now,
    .timetable-content.booked.now {
        background-color: #6699ff;
    }

    .timetable-content.future,
    .timetable-content.course.future,
    .timetable-content.transferred.future,
    .timetable-content.booked.future {
        background-color: #6699ff;
        cursor: default;
    }

    .timetable-content.booked.now,
    .timetable-content.booked.past,
    .timetable-content.booked.future {
        background-color: blanchedalmond;
    }

</style>
